<template>
  <div class="zj-emergencyIncident-infopanel">
    <el-row type="flex" justify="space-between">
      <el-col class="seq" :span="2">
        <div>{{info.index + 1}}</div>
      </el-col>
      <el-col :span="22" class="zj-emergencyIncident-infopanel-detail">
        <el-row type="flex" justify="space-between">
          <label class="name">事件名称：{{info.eventName}}</label>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="6">
            <el-row>
              <label>应急用时:</label>
              <label class="contact">{{emergencyWhen}}</label>
            </el-row>
            <el-row>
              <label>事件类型:</label>
              <label class="contact">{{info.eventTypeTranslated}}</label>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <label>接报时间:</label>
              <label class="contact">{{info.reportTime}}</label>
            </el-row>
            <el-row>
              <label>事件等级:</label>
              <label class="contact">{{info.eventLevelTranslated}}</label>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <label>报送人:</label>
              <label class="contact">{{info.reportName}}</label>
              <label class="contact">{{info.reportContact}}</label>
            </el-row>
            <el-row></el-row>
          </el-col>
          <el-col class="detail-list-btn-col" :span="6">
            <el-button @click.stop="showinventoryList" class="detail-list-btn">进入应急作战指挥</el-button>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="24">
            <el-row>
              <label>事发地点:</label>
              <label>{{info.eventAddress}}</label>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import dayjs from 'dayjs'
export default {
  name: "ZJComponent-InfoPanel",
  props: {
    info: {
      required: true,
      type: Object
    },
    type: {
      required: true,
      type: String
    },
    currentDate:{
      require:true,
      type:Date
    }
  },
  data() {
    return {
      emergencyWhen:''
    };
  },
  created:function(){
    var new_date = this.currentDate; 
    var old_date = new Date(this.info.reportTime);
    
    var difftime = (new_date - old_date)/1000; //计算时间差,并把毫秒转换成秒
    
    var days = parseInt(difftime/86400); // 天  24*60*60*1000 
    var hours = parseInt(difftime/3600)-24*days;    // 小时 60*60 总小时数-过去的小时数=现在的小时数 
    var minutes = parseInt(difftime%3600/60); // 分钟 -(day*24) 以60秒为一整份 取余 剩下秒数 秒数/60 就是分钟数
    var seconds = parseInt(difftime%60);  // 以60秒为一整份 取余 剩下秒数

    this.emergencyWhen = days + '天' + hours + "小时" + minutes + '分' + seconds + '秒'
  },
  methods: {
    showinventoryList() {
      this.$router.push({
        path: "/plugin/emergency/ui/EmergencyOperations",
        query: {
          ExecutId: this.info.id
        }
      });
    }
  }
};
</script>

<style>
</style>